import css from "standard/css";

const style = css`
  .modal__overlay {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(0, 0, 0, 0.5);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 1;
  }

  .modal {
    background-color: var(--color-pure-white);
    border-radius: var(--border-radius-sm);
    padding: var(--spacing_inset-lg);
    justify-content: center;
    align-items: center;
    flex-direction: column;
    display: flex;
    max-width: 590px;
    gap: var(--spacing_inset-xs);
    align-self: center;
    position: relative;
    width: 90%;
    z-index: 2;
  }

  .modal[close="false"]
  .modal__overlay[close="false"] {
    display: none;
  }

  .modal__button {
    align-items: center;
    background-color: var(--color-ocean);
    border: none;
    border-bottom: 2px solid var(--color-ocean-light);
    border-radius: 12px;
    box-shadow: 0 10px 0 var(--color-ocean-dark);
    color: var(--color-pure-white);
    cursor: pointer;
    display: flex;
    font-family: var(--font-family-highlight);
    font-size: var(--font-size-md);
    font-weight: var(--font-weight-bold);
    gap: var(--spacing-xxxs);
    height: 50px;
    justify-content: center;
    width: 100%;
  }

  .modal__button:active {
    box-shadow: none;
    transform: translateY(5px);
  }

  .modal__texts {
    display: flex;
    align-items: center;
    justify-content: center;
    font-family: var(--font-family-highlight);
    flex-direction: column;
    gap: var(--spacing_inset-xs);
    color: var(--color-master);
  }

  .modal__congratulations {
    display: flex;
    flex-direction: column;
    align-items: center;
    font-size: var(--font-size-md);
    font-weight: var(--font-weight-bold);
    color: var(--color-master);
  }
`;

export default style;
